import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import BaseLayout from '../layouts/BaseLayout';
import { Data } from '../components';
import Hero from '../partials/Hero';

const Privacy = props => {
  const {
    data: {
      file: { childDataYaml: pageData },
    },
  } = props;

  return (
    <BaseLayout>
      <Helmet
        title={pageData.title}
        meta={[{ name: 'description', content: pageData.description }]}
      />
      <Hero
        particles={false}
        compact
        className="u-gradient--darkerBlue-darkestBlue"
      >
        <div className="hero-content">
          <div className="container">
            <div className="hero-titleWrapper">
              <h1 className="hero-title">
                <Data>{pageData.hero.heading}</Data>
              </h1>
            </div>
          </div>
        </div>
      </Hero>
      <section className="section">
        <div className="container container--small">
          <Data markdown>{pageData.body}</Data>
        </div>
      </section>
    </BaseLayout>
  );
};

Privacy.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Privacy;

export const pageQuery = graphql`
  query PrivacyPageData {
    file(name: { eq: "privacy" }) {
      childDataYaml {
        title
        description
        hero {
          heading
        }
        body
      }
    }
  }
`;
